// Ownership Verification View
import { t } from '../i18n.js';

/**
 * Create verification page view
 * @returns {string} HTML string
 */
export function createVerificationView() {
  return `
    <div class="landing-page" style="min-height: 100vh; display: flex; flex-direction: column;">
      <nav class="lp-nav">
        <div class="lp-nav-inner flex justify-between items-center">
          <a class="lp-nav-logo" href="#/">
            <span class="icon">🏛️</span>
            <span>ArchaeoHub</span>
          </a>
        </div>
      </nav>

      <main style="flex: 1; display: flex; align-items: center; justify-content: center; padding: 4rem 2rem;">
        <div style="max-width: 800px; background: white; padding: 3rem; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.1); border: 1px solid #eee;">
          <div style="display: flex; align-items: center; gap: 1rem; margin-bottom: 2rem; color: #1a73e8;">
            <span style="font-size: 2.5rem;">📜</span>
            <h1 style="margin: 0; font-size: 2rem; color: #202124;">Ownership Verification</h1>
          </div>
          
          <div style="line-height: 1.8; color: #3c4043; font-size: 1.1rem;">
            <p style="margin-bottom: 1.5rem;">
              <strong>Date:</strong> ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
            
            <p style="margin-bottom: 1.5rem;">
              This official statement serves as proof of ownership and authorization for the <strong>ArchaeoHub</strong> digital platform and its associated mobile applications.
            </p>

            <div style="background: #f8f9fa; padding: 2rem; border-left: 4px solid #1a73e8; border-radius: 8px; margin: 2rem 0;">
              <p style="margin-bottom: 1rem;">
                The website located at <strong>https://archaeohub.com.tr</strong> (and any associated domains) is the sole property of, and is operated by, <strong>Harmony Group Tech</strong>.
              </p>
              <p>
                <strong>Harmony Group Tech</strong> is the official developer and administrator of the <strong>ArchaeoHub</strong> application on the Google Play Store.
              </p>
            </div>

            <p style="margin-bottom: 1.5rem;">
              We hereby declare that:
            </p>
            <ul style="margin-bottom: 2rem; padding-left: 1.5rem; list-style-type: disc;">
              <li style="margin-bottom: 1rem;">The ArchaeoHub mobile application is an extension of this web platform.</li>
              <li style="margin-bottom: 1rem;">Harmony Group Tech has full rights and authorization to use, distribute, and display all content within the ArchaeoHub platform.</li>
              <li style="margin-bottom: 1rem;">The integration of web views within our mobile applications is intentional and authorized by the platform administrators.</li>
            </ul>

            <div style="border-top: 1px solid #eee; padding-top: 2rem; margin-top: 3rem;">
              <p style="margin-bottom: 0.5rem;"><strong>Contact Information:</strong></p>
              <p style="margin-bottom: 0.5rem;">Harmony Group Tech</p>
              <p style="margin-bottom: 0.5rem;">Email: <a href="mailto:gulerege.tr@gmail.com" style="color: #1a73e8; text-decoration: none;">gulerege.tr@gmail.com</a></p>
              <p style="margin-bottom: 0.5rem;">Email: <a href="mailto:bircegulerdev@gmail.com" style="color: #1a73e8; text-decoration: none;">bircegulerdev@gmail.com</a></p>
              </div>
          </div>
        </div>
      </main>

      <footer class="lp-footer">
        <div class="container">
          <div class="lp-footer-inner flex justify-between items-center">
            <div class="lp-nav-logo">
              <span>🏛️</span>
              <span>ArchaeoHub</span>
            </div>
            <div class="lp-footer-copy">© 2026 ArchaeoHub by Harmony Group Tech</div>
          </div>
        </div>
      </footer>
    </div>
  `;
}

/**
 * Initialize verification page events
 */
export function initVerificationView() {
  // No interactive events needed for this static page
}
